const env = {
   identityApi: "identityapi",
   backend: "applicationapi"
}

export default env;